import { i18n } from '@plugins/i18n'

function generateConfirm(type) {
  return {
    title: i18n.t(`confirm.${type}.title`),
    msg: i18n.t(`confirm.${type}.msg`),
    btn: i18n.t(`confirm.${type}.btn`),
    close_btn: i18n.t(`confirm.${type}.close_btn`),
  }
}

const confirmTypeProps = {
  type: {
    validator: function(value) {
      return !!~[
        '',
        'add',
        'edit',
        'edit_agent_admin',
        'update',
        'delete',
        'quitagent',
        'deliver_start',
        'deliver_end',
        'revoke',
        'accept',
        'reject',
        'serverdown',
        'unselected',
        'invalidselected',
        'member_cannot_unbind',
        'change_password',
        'member_status_apply',
        'send_mail',
        'forget_password',
        'feedback',
        'wait',
        'request_revoke',
        'request_revoke_confirm',
      ].indexOf(value)
    },
  },
}
export { generateConfirm, confirmTypeProps }
